module.exports = __webpack_public_path__ + "assets/goods.8e36334f.svg";